import {USER_TYPE} from './types';

export const getUser = data => ({
  type: USER_TYPE,
  payload: data,
});
